<template>
  <div class="py-2 m-0 bg-white">
    <v-container style="max-width: 1800px">
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <div>
            <div>{{ subTitleTop }}</div>
            <h2 class="py-0 mb-0 font-weight-bold">
              {{ content }}
              <v-badge
                right
                color="blue lighten-4 "
                class="ml-3"
                v-if="badgeContent"
              >
                <span slot="badge" class="blue--text">{{ badgeContent }}</span>
                <!--slot can be any component-->
              </v-badge>
            </h2>
            <div class="">
              {{ subTitleBottom }}
            </div>
          </div>
          <div>
            <slot name="append-content"></slot>
          </div>  
        </div>
        <div class="d-flex">
          <slot />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import AddArea from "./AddArea.vue";
export default {
  name: "Headline",
  created() {},
  data() {
    return {};
  },
  props: ["subTitleTop", "content", "subTitleBottom", "badgeContent"],
  methods: {},
};
</script>

<style lang="scss" scoped></style>
